import React, { useEffect, useState } from 'react';
import { Pressable, View, SxProp } from 'dripsy';

import { TextBody } from '@/design-system/components/typography/UniTypography';

export interface UniCheckboxProps {
  label?: string;
  options?: {
    height?: number;
    width?: number;
    labelColor?: string;
    labelSecondaryColor?: boolean;
  };
  verticalAlignCenter?: boolean;
  sx?: SxProp;
  disabled?: boolean;
  value: boolean;
  onValueChange: (value: boolean) => void;
}

export const UniCheckbox: React.FC<UniCheckboxProps> = ({
  label,
  options,
  value,
  verticalAlignCenter,
  onValueChange,
  sx,
  disabled,
  children
}) => {
  let containerStyle = styles.container;
  if (verticalAlignCenter) {
    containerStyle = { ...containerStyle, ...styles.containerCenterAlign };
  } else {
    containerStyle = { ...containerStyle, ...styles.containerTopAlign };
  }

  return (
    <Pressable onPress={() => !disabled && onValueChange(!value)} sx={{ ...containerStyle, ...sx }}>
      <View
        sx={{
          ...(value ? styles.boxChecked : styles.box),
          height: options?.height || 20,
          width: options?.width || 20
        }}>
        <TextBody sx={{ color: value ? '$backgroundPrimary' : '$backgroundPrimary' }}>{value ? '✓' : ''}</TextBody>
      </View>
      {children && children}
      {label && (
        <TextBody
          sx={{
            ...styles.label,
            color: options?.labelColor ? options.labelColor : options?.labelSecondaryColor ? '$textSecondary' : '$textPrimary'
          }}>
          {label || 'Checkbox Label'}
        </TextBody>
      )}
    </Pressable>
  );
};

const styles: Record<string, SxProp> = {
  container: {
    flexDirection: 'row'
  },
  containerCenterAlign: {
    alignItems: 'center'
  },
  containerTopAlign: {
    alignItems: 'flex-start'
  },
  box: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$borderPrimary',
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent'
  },
  boxChecked: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '$secondary',
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '$secondary'
  },
  boxText: {
    color: '$backgroundPrimary'
  },
  label: {
    marginLeft: 8,
    // marginRight: 16,
    fontSize: 12,
    lineHeight: 15,
    textAlign: 'left'
  }
};
